import styled from "styled-components";
import "./LoadingScreen.css"

const PageLoader = styled.div`
  display: flex;
  flex-direction: column; 
  padding-top: 10%;
  align-items: center;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: 500px){    
    padding-top: 40%;
  }
`;



export default function LoadingScreen({ didVideoPlay, setDidVideoPlay }: any) {
    return (
        <PageLoader>
            <video
                autoPlay
                muted
                controls={false}
                playsInline
                src="assets/preloader.mp4"
                className="vidloader"
                style={{ aspectRatio: "1" }}
                onEnded={() => setDidVideoPlay(true)}
            />            
        </PageLoader>
    );
}

